const isColorPreviewed = ref(false)

export default function useColorPreview() {
  const setColorPreviewed = (value: boolean) => {
    isColorPreviewed.value = value
  }

  return { isColorPreviewed, setColorPreviewed }
}
